<template>
  <div class="document-item-lite d-flex i-mb-6">
    <div
      class="document-item-lite__thumbnail d-flex flex-column justify-content-center align-items-center i-p-6"
    >
      <img v-if="thumbnail" :src="thumbnail" alt="thumbnail" />
    </div>
    <div
      class="document-item-lite__content i-m-8 d-flex flex-column justify-content-center"
    >
      <p class="filename i-text-button-2">{{ filename }}</p>
      <p class="i-text-body-2 i-text-neutral-100">
        {{ secondLine || 'Successfully added' }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    secondLine: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.document-item-lite {
  min-height: 90px;
  overflow: hidden;
  width: 100%;
  border: 1px solid $light-neutral-60 !important;
  border-radius: $base-unit * 2 !important;

  &__thumbnail {
    width: 88px;
    flex-shrink: 0;
    background: $light-neutral-30;

    img {
      height: 65px;
    }
  }

  &__content {
    width: 315px;

    .filename {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
